import React from "react";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { Layout } from "@/dto/item";

export const ItemList = ({
  listType,
  children,
  layout = "default",
}: {
  listType?: string;
  children?: any;
  layout?: Layout;
}) => {
  return (
    <div
      data-testid={applyDataTestId(pom.landingPage.productListing)}
      className={[
        "grid",
        "grid-cols-1",
        "gap-x-6",
        `${layout === "enhanced" ? "gap-y-4" : "gap-y-10"}`,
        "sm:grid-cols-1",
        "lg:grid-cols-2",
        `${layout === "enhanced" ? "xl:gap-x-4" : "xl:gap-x-8"}`,
        "justify-center",
        `${
          listType?.toLowerCase() === "image focused" &&
          "grid-cols-2 sm:grid-cols-2 lg:grid-cols-4"
        }`,
        `${
          listType?.toLowerCase() === "description focused" &&
          " grid-cols-1 sm:grid-cols-1 lg:grid-cols-2"
        }`,
      ].join(" ")}
    >
      {children}
    </div>
  );
};
